import {
  CancelInvoiceBody,
  InvoiceOrderBody,
  LogCreatePaymentCreditCard,
  LogCreatePaymentBit,
  LogCreatePaymentRecurring,
  LogCreatePaymentPayPal
} from "../types";

const getString = (arr: string[]) => arr.filter(Boolean).join(' ');

export const actionLogMessages = {
  LOGIN: (username: string) => getString(['משתמש', username, 'ביצע לוגין למערכת']),
  LOGOUT: (username: string) => getString(['משתמש', username, 'ביצע לוגאוט מהמערכת']),
  CHANGE_PASSWORD: () => getString(['שינוי סיסמה במסך הגדרות בוצע עבור משתמש']),
  LOGIN_BY_PHONE: (phone: string) => getString(['קוד חד פעמי לכניסה אושר עבור', phone]),
  LOGIN_AS_ADMIN: (username: string) => getString(['משתמש', username, 'התחבר למערכת כאדמין']),
  ORDER_INVOICE: ({customerName, idNumber, address, phone, emailRecipients, contact}: InvoiceOrderBody) =>
    getString([
      'הזמנת חשבונית עם הפרטים הבאים: שם לקוח -', `${customerName},`, 'תז -', `${idNumber},`, 'כתובת -', `${address},`,
      'טלפון -', `${phone},`, 'מייל -', `${emailRecipients},`, 'איש קשר -', `${contact}`, 'בוצעה'
    ]),
  CANCEL_INVOICE: ({invoiceNum, customerEmail, comments, datetime}: CancelInvoiceBody) =>
    getString([
      'חשבונית: מספר -', `${invoiceNum},`, 'מייל - ', `${customerEmail},`, 'הערות - ', `${comments}`, 'בוטלה'
    ]),
  CREATE_PAYMENT_CREDIT_CARD: ({invoiceID, items, customerName, phone, email, currency,
                                 payerIsCustomer, payerName, payerEmail, payerPhone}: LogCreatePaymentCreditCard) =>
    getString([
      'בקשה ללינק לתשלום בכרטיס אשראי:', `מספר חשבונית - ${invoiceID},`, 'שם לקוח -', `${customerName},`, 'טלפון -',
      `${phone}`, 'מייל -', `${email},`, 'מטבע -',
      items.map(item => item.amount).reduce((sum, current) => sum + current, 0).toString(), `${currency}`,
      payerIsCustomer ? '' : 'שם המשלם -', payerIsCustomer ? '' : `${payerName},`,
      payerIsCustomer ? '' : 'מייל המשלם -', payerIsCustomer ? '' : `${payerEmail},`,
      payerIsCustomer ? '' : 'טלפון המשלם -', payerIsCustomer ? '' : `${payerPhone}`,
      ]),
  CREATE_PAYMENT_BIT: ({amount, description, customerName, phone, email}: LogCreatePaymentBit) =>
    getString([
      'בקשה ללינק לתשלום בביט: סכום -', `${amount.toString()},`, 'תיאור -', `${description},`, `שם לקוח -`, `${customerName},`,
      'טלפון -', `${phone},`, 'מייל -', `${email}`
    ]),
  CREATE_PAYMENT_RECURRING: ({amount, description, recurringPeriod, paymentsCount, startDate, customerName,
                               email, phone}: LogCreatePaymentRecurring) =>
    getString([
      'בקשה לתשלום בהוראת קבע: סכום -', `${amount.toString()},`, 'תיאור -', `${description},`,
      'שם לקוח -', `${customerName},`, 'טלפון -', `${phone},`, 'מייל -', `${email},`, 'תקופת תשלום -', `${recurringPeriod.toString()},`,
      'מספר תשלומים -', `${paymentsCount.toString()},`, 'תאריך תחילה -', startDate ? startDate.toString() : ''
    ]),
  CREATE_PAYMENT_PAYPAL: ({currency, description, amount, invoiceOrderID, invoiceID,
                            phone, email, customerName}: LogCreatePaymentPayPal) =>
    getString([
      'בקשה לתשלום בפייפאל: סכום -', `${amount.toString()},`, 'תיאור -', `${description},`, 'מטבע - ', `${currency},`,
      customerName ? `שם לקוח -${customerName || ''}` : '',
      phone ? `טלפון - ${phone || ''},` : '',
      email ? `מייל - ${email || ''}` : '',
      invoiceID ? `, מספר חשבונית - ${invoiceID || ''}` : ''
    ]),
  CREATE_INVITATION: (name: string, phone: string) => getString(['הזמנת חבר', name, 'בטלפון', phone]),
};